import router from "../../../router";
import axios from "axios";

export default {
    loadInvoiceList({ commit, dispatch }, payload)
    {
        return new Promise((resolve, reject) => {
            let filter_fields = this.getters['invoices/getInvoiceFilterFields'];
            let main_filter = this.getters['invoices/getInvoiceMainFilter'];

            dispatch('pagePreloader/setPagePreloaderIsActive', true, {root: true});

            commit('setInvoiceList', []);

            if (!main_filter && router.currentRoute.query.main_filter) {
                main_filter = router.currentRoute.query.main_filter;

                commit('setInvoiceFilterFieldsMutation', {main_filter: router.currentRoute.query.main_filter});
            }

            if (!filter_fields.invoiceCompanyId && router.currentRoute.query.inovice_company_id) {
                filter_fields.invoiceCompanyId = router.currentRoute.query.inovice_company_id;

                commit('setInvoiceFilterFieldsMutation', {field_name: 'invoiceCompanyId', field_value: router.currentRoute.query.inovice_company_id})
            }

            payload['filter_fields'] = filter_fields;
            payload['main_filter'] = main_filter;

            axios.post('/api/invoice/list-admin', payload).then((response) => {
                const result = response.data.data;

                if (response.data.data.code != 'ok')
                {
                    resolve({
                        error: true,
                        error_msg: 'Server response code not ok!',
                    });

                    return;
                }

                if (!response.data.data.result) {
                    resolve({
                        error: true,
                        error_msg: 'Result is empty!',
                    });

                    return;
                }

                dispatch('pagePreloader/setPagePreloaderIsActive', false, {root: true});

                commit('setInvoiceList', response.data.data.result.invoices);
                commit('setInvoiceListCount', response.data.data.result.invoices_count);

                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    },
    setInvoiceFilterFields({ commit }, payload)
    {
        commit('setInvoiceFilterFieldsMutation', payload);
    },
}
